import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// MUI
import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Skeleton } from "@mui/material";

const options = [
	{ value: "NO_SPLIT", label: "No Split Deals" },
	{ value: "SPLIT_LEASE", label: "Split Lease Deals" },
	{ value: "SPLIT_CASH", label: "Split Cash Deals" },
	{ value: "SPLIT_LEASE_AND_CASH", label: "Split Lease and Cash Deals" },
];

export default function PerformanceNormalization(props) {
	const {
		sectionId = "backendPVRComputation",
		normalization = "NO_SPLIT",
		loading = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	const [value, setValue] = useState("NO_SPLIT");

	const handleChange = (_, selectedValue) => {
		setValue(selectedValue);
		onActionUpdate?.(sectionId, null, selectedValue);
	};

	useEffect(() => {
		setValue(normalization || "NO_SPLIT");
		return () => {
			setValue("NO_SPLIT");
		};
	}, [normalization]);

	return (
		<Stack spacing={1} mt={1.8} marginLeft="32px">
			<FormControl>
				<RadioGroup
					name="pvr-computation-group"
					value={value || "NO_SPLIT"}
					onChange={handleChange}
					className={"radio-buttons-small regular-blue-color"}
				>
					{options.map(({ value: key, label }) =>
						loading ? (
							<Skeleton key={key} width={250} />
						) : (
							<FormControlLabel
								key={key}
								value={key}
								control={
									<Radio
										sx={{
											"& .MuiSvgIcon-root": {
												fontSize: 20,
											},
										}}
									/>
								}
								label={label}
								disabled={loading || readOnly}
							/>
						)
					)}
				</RadioGroup>
			</FormControl>
		</Stack>
	);
}
PerformanceNormalization.propTypes = {
	sectionId: PropTypes.string,
	normalization: PropTypes.string,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
